import React from 'react';
import LocalImages from '../../../static';
import { FaFileAlt } from "react-icons/fa";
import { downloadFile } from 'src/app/utilities/helpers';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'src/app/navigation/routes';

type AttachmentType = {
    name: string;
    url: string;
}

type MessageAttachmentProps = {
    attachments: Array<AttachmentType>
};

const MessageAttachments: React.FC<MessageAttachmentProps> = ({ attachments }) => {

    const navigate = useNavigate();

    const handleAttachmentClick = (item : AttachmentType) => {
        navigate(AppRoutes.DOCUMENT_VIEWER, {state : {docs : [{uri : item.url}], headerTitle: item.name}})
    }

    const attachmentsItems = (item: AttachmentType, index: number) => {
        return (
            <div className='message-attachment-item cursor-pointer' key={index}>
                <p className='message-attachment-icon' onClick={() => handleAttachmentClick(item)}>
                    <FaFileAlt size={20} color='#C4C4C4' />
                </p>
                <p className='message-attachment-name' onClick={() => handleAttachmentClick(item)}>
                    <p>{item.name}</p>
                </p>
                <div className='message-attachment-download cursor-pointer' onClick={() => downloadFile(item.url)}>
                    <div className='cursor-pointer'>
                        <img src={LocalImages.downloadIconSvg} />
                    </div>
                </div>
            </div>
        )
    };

    return (
        attachments.map((item: AttachmentType, index: number) => attachmentsItems(item, index))
    );
};

export default MessageAttachments;
